<template>
  <div>
    <div class="text-center vmore">
      <b-row>
        <b-col class="text-left p-0 m-0">
          <p class="showing-text">
            Showing {{ intervalnum * pages - intervalnum + 1 }} -
            {{ endnum > endss ? endss : endnum }} of {{ endss }}
          </p>
        </b-col>
        <b-col class="text-center p-0 m-0">
          <b-form-group class="label" label-for="target">
            <b-form-select
              id="target"
              v-model="localintervalnum"
              @change="changeInterval"
              :options="levels"
              required
            >
              <b-form-select-option value="null"
                >-- Select --</b-form-select-option
              >
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col class="text-right p-0 m-0 button-pager-group">
          <b-button-group size="xs">
            <b-button
              v-for="(page, index) in ranger"
              :key="index"
              :page="page"
              :class="[pages == page ? 'active-page-btn' : '']"
              @click="newPage(page)"
              class="ml-1 page-buttons"
              size="xs"
              variant="outline-dark"
              >{{ page }}</b-button
            >
          </b-button-group>
        </b-col>
      </b-row>
      <!-- <div class="viewmore" @click="showMore">
                <b-icon-chevron-down font-scale="2" class="mt-3" animation="cylon-vertical">View More</b-icon-chevron-down>
            </div>
            <p class="p-1 m-1 textboldsf">Show More</p> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["intervalnum", "pages", "endnum", "endss", "datalength", "total"],
  data() {
    return {
      levels: [10, 25, 50, 100, 250, 500],
      localintervalnum: 10
    };
  },
  created() {
    this.localintervalnum = this.intervalnum;
  },
  methods: {
    newPage(page) {
      // alert(page)
      this.$emit("paginator", page);
    },
    changeInterval() {
      this.$emit("changeInterval", this.localintervalnum);
    }
  },
  computed: {
    ranger() {
      let ranger = Math.ceil(this.datalength / this.intervalnum);
      return ranger;
    }
  }
};
</script>

<style scoped>
.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}

.page-buttons {
  width: 35px;
  height: 35px;
}
.active-page-btn {
  background-color: #263056;
  color: white;
}
.button-pager-group {
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: thin;
}

@media (max-width: 999px) {
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
  .showing-text{
    font-size:14px;
    margin-top:10px
  }
}
</style>
